import React, { useRef, useState } from 'react'
import { GameCssStyles } from '../GameCssStyles'
import { Box, Button, TextField, Typography } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs from 'dayjs'
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket'

const StandardAboutGame = ({ formGameData, handleChange }) => {

    const fileInputRef = useRef(null);

    const handleGameBannerChnageUploadImageBTClick = () => {
        fileInputRef.current.click();
    }

    const handleGameBannerFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const mimeType = file.type;
            var type = "unknown";
            if (mimeType.startsWith("image/")) {
                type = "image";
            }
            console.log("File selected:", file, "URL:", url, "Type:", type);
            const result = await uploadFileToAWSS3Bucket("banners", file);
            console.log("Upload AWS result : ", result)
            const fileResult = await getSingleFileByNameFromAWSS3Bucket("banners", result?.key?.split('/').pop());
            console.log("Single File AWS fileResult : ", fileResult)
            handleChange("banner", fileResult);
        }
        else {
            console.error("No file selected");
            handleChange("banner", "");
        }
    }

    const createDateInMilliseconds = (path) => {
        const currentDate = new Date();
        const transformedDate = dayjs(currentDate);
        const milliseconds = transformedDate.valueOf();
        handleChange(path, milliseconds);
        return transformedDate;
    }

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>About Game</Typography>

            <Box display="flex" alignItems="stretch" gap={3} mt={0} width="100%">
                <TextField
                    fullWidth
                    label="Title"
                    multiline={false}
                    rows={1}
                    value={"Rap League"}
                    InputProps={{ readOnly: true }}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
                <TextField
                    fullWidth
                    label="Sub Title"
                    multiline={false}
                    rows={1}
                    value={"Rap League"}
                    InputProps={{ readOnly: true }}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
            </Box>

            <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={3}>
                <TextField
                    fullWidth
                    label="Game Banner URL"
                    multiline={false}
                    rows={1}
                    value={formGameData?.banner || ''}
                    onChange={(e) => handleChange("banner", e.target.value)}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
                <>
                    <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleGameBannerFileChange}
                    />
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ height: "100%" }}
                        onClick={handleGameBannerChnageUploadImageBTClick}
                    >
                        {formGameData?.banner ? "Change" : "Upload"}
                    </Button>
                </>
            </Box>

            {/* <Box display="flex" alignItems="stretch" gap={3} mt={3} width="100%">
                <TextField
                    fullWidth
                    label="Term & Condition URL"
                    multiline={false}
                    rows={1}
                    value={formGameData?.rules?.termsConditionsUrl}
                    onChange={(e) => handleChange("rules.termsConditionsUrl", e.target.value)}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />

                <TextField
                    fullWidth
                    label="Source of Truth URL"
                    multiline={false}
                    rows={1}
                    value={formGameData?.rules?.sourceOfTruthUrl}
                    onChange={(e) => handleChange("rules.sourceOfTruthUrl", e.target.value)}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
            </Box> */}

            {/* <Box display="flex" alignItems="stretch" gap={3} mt={3} width="100%">
                <TextField
                    fullWidth
                    label="About Game"
                    multiline
                    rows={10}
                    value={formGameData?.rules?.aboutGame}
                    onChange={(e) => handleChange("rules.aboutGame", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />

                <TextField
                    fullWidth
                    label="Contest Rules"
                    multiline
                    rows={10}
                    value={formGameData?.rules?.rules}
                    onChange={(e) => handleChange("rules.rules", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />

                <TextField
                    fullWidth
                    label="Source of Truth"
                    multiline
                    rows={10}
                    value={formGameData?.rules?.sourceOfTruth}
                    onChange={(e) => handleChange("rules.sourceOfTruth", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />
            </Box> */}


            <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="column" gap={3} mt={3}>
                <DateTimePicker
                    label="Go Live"
                    minDateTime={dayjs()}
                    //maxDateTime={dayjs().subtract(30, 'day')} 
                    value={formGameData?.rules?.goLiveAt ? dayjs(formGameData?.rules?.goLiveAt) : null}
                    onChange={(v) => {
                        const milliseconds = dayjs(v).valueOf();
                        console.log("Go Live At Changed", milliseconds);
                        handleChange("rules.goLiveAt", milliseconds);
                        const submissionCutOffAt = milliseconds + 12 * 60 * 60 * 1000;
                        const resultDeclarationAt = milliseconds + 84 * 60 * 60 * 1000;
                        const alterCutOffAt = Math.floor((submissionCutOffAt + resultDeclarationAt) / 2);
                        handleChange("rules.submissionCutOffAt", submissionCutOffAt);
                        handleChange("rules.alterCutOffAt", alterCutOffAt);
                        handleChange("rules.resultDeclarationAt", resultDeclarationAt);
                        handleChange("forkContestRules", [
                            {
                                "contestType": "Paid",
                                "isPromoted": false,
                                "ticketPrice": {
                                    "rapCoin": 500,
                                    "money": {
                                        "value": 0,
                                        "currency": "inr"
                                    }
                                }
                            }
                        ])
                    }}
                    slotProps={{ textField: { fullWidth: true } }}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />

                <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={1}>
                    <DateTimePicker
                        label="Submission Cutoff At"
                        minDateTime={dayjs()}
                        value={formGameData?.rules?.submissionCutOffAt ? dayjs(formGameData?.rules?.submissionCutOffAt) : null}
                        onChange={(v) => {
                            const milliseconds = dayjs(v).valueOf();
                            handleChange("rules.submissionCutOffAt", milliseconds);
                        }}
                        disabled = {false}
                        slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />

                    <DateTimePicker
                        label="Alter Cutoff At"
                        minDateTime={dayjs()}
                        value={formGameData?.rules?.alterCutOffAt ? dayjs(formGameData?.rules?.alterCutOffAt) : null}
                        onChange={(v) => {
                            const milliseconds = dayjs(v).valueOf();
                            handleChange("rules.alterCutOffAt", milliseconds);
                        }}
                        disabled = {false}
                        slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />

                    <DateTimePicker
                        label="Result Declaration At"
                        minDateTime={dayjs()}
                        value={formGameData?.rules?.resultDeclarationAt ? dayjs(formGameData?.rules?.resultDeclarationAt) : null}
                        onChange={(v) => {
                            const milliseconds = dayjs(v).valueOf();
                            handleChange("rules.resultDeclarationAt", milliseconds);
                        }}
                        disabled = {false}
                        slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                        sx={GameCssStyles.formSingleLineTextField_sx}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default StandardAboutGame
